export default "/_next/static/3f10213d92766d7df663b39d8406915c.jpg";